import { render, staticRenderFns } from "./ticketShow.vue?vue&type=template&id=0b0eaa33&scoped=true"
import script from "./ticketShow.vue?vue&type=script&lang=js"
export * from "./ticketShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0eaa33",
  null
  
)

export default component.exports